import React, { useEffect, useRef, useState } from "react";
import "./Seller_best.css";
import axios from "axios";
import { toast } from "react-toastify";
import {Link} from "react-router-dom";

export default function Sellar_best() {
  const [data, setData] = useState([]);
  const headRef = useRef(null);
  const cardRefs = useRef([]);

  useEffect(() => {
    if (!data.length) return;
  
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1 }
    );
  
    if (headRef.current) observer.observe(headRef.current);
  
    cardRefs.current.forEach((el) => {
      if (el) observer.observe(el);
    });
  
    return () => observer.disconnect();
  }, [data]);

  useEffect(() => {
    try {
      const fetchData = async () => {
        const response = await axios.post("https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_create_product");
        const filteredData = response.data.data.filter(item =>
           item.product_status === "Best Sellers" &&
           item.admin_approval === "approval" &&
           item.paid_promo === "yes");
        setData(filteredData);
      }
      fetchData();
    } catch (error) {
      toast.error("Failed to fetch best sellers.");
    }
  }, []);

  return (
    <section className="sellar-section">
      <div className="sellar-wrapper">

        <div className="sellar-head" ref={headRef}>
          <h2 className="sellar-title-text">Best Sellers</h2>
        </div>

        <div className="sellar-grid-layout">
          {data.map((item, index) => (
            <div
              key={item.id}
              className="sellar-item-card"
              ref={(el) => (cardRefs.current[index] = el)}
              style={{ '--delay': `${index * 90}ms` }}
            >
              <div className="sellar-visual">
                <img src={`https://cyberathon.com/multivendor/${item.multi_image[0]}`} alt={item.product_name} />
                {/* <div className="sellar-fav">♡</div> */}
                <div className="sellar-add-layer">
                   <Link
          key={index}
          to={`/model/${item.product_id}`}
          className="w-100"
          >
                  <button className="sellar-btn-add">QUICK ADD</button>
                    </Link>
                </div>
              </div>

              <div className="sellar-content">
                <h3 className="sellar-product-title">{item.product_name}</h3>
                <div className="sellar-price-info">
                  <span className="sellar-price-new">{item.current_price}</span>
                  <span className="sellar-price-old">{item.old_price}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}